export default __webpack_public_path__ + "static/media/logo_EDO_school.1acf6483.svg";